import styled from 'styled-components'
import { Trans, useTranslation } from 'react-i18next'
import { colors, fontWeights } from '@/styles'
import { Button } from '@/components/button'
import Icon from '@/components/icon'

const TopProgressBar = styled.div`
  width: 100%;
  height: 48px;
  background-color: #27567d;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${colors.white};
  font-size: 14px;
  line-height: 16px;
  font-weight: ${fontWeights.medium};
  padding: 0 24px;
  position: sticky;
  top: 53px;
  z-index: 10;
  min-height: 48px;
`

const ChevronNext = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  color: ${colors.blue16};
`

const IsSigningComponent = ({
  progressStart,
  itemsLength,
  signingFinished,
  handleSubmit,
  handleNextField
}) => {
  const { t } = useTranslation()
  return (
    <TopProgressBar>
      <div>
        <Trans
          i18nKey="l.contract_edit.document_widget.progress.label"
          progressStart={progressStart}
          itemsLength={itemsLength}
        >
          {{ progressStart }} of {{ itemsLength }}
        </Trans>
        {signingFinished &&
          t(
            'l.contract_edit.document_widget._complete.label',
            ' - Select “Submit” to send the completed document.'
          )}
      </div>
      <Button
        theme="secondary"
        size="small"
        padding="8px 16px"
        minHeight="unset"
        type="submit"
        onClick={signingFinished ? handleSubmit : handleNextField}
      >
        {signingFinished ? (
          'Submit'
        ) : (
          <>
            Next Field{' '}
            <ChevronNext>
              <Icon id="chevron_right_enabled" height="8px" width="5px" />
            </ChevronNext>
          </>
        )}
      </Button>
    </TopProgressBar>
  )
}

export default IsSigningComponent
